import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueAnimateOnScroll from "vue3-animate-onscroll";
import currencyFormat from "@/utils/formatCurrency";
import { tooltip } from "@ionited/tooltip-vue";
import "vue-toast-notification/dist/theme-sugar.css";
import "v-calendar/style.css";
import "qalendar/dist/style.css";
import "vue3-carousel/dist/carousel.css";
import "./assets/tailwind.css";

createApp(App)
  .use(store)
  .use(router)
  .use(VueAnimateOnScroll)
  .directive("tooltip", tooltip)
  .provide("currencyFormat", currencyFormat)
  .mount("#app");
